import Icon from './Icon';
import Base from './Base';
import Text from './Text';
import Body from './Body';
import ContentWrapper from './ContentWrapper';
import Title from './Title';
import SubTitle from './SubTitle';
import JsonLdFaq from './JsonLdFaq';
import TitleWrapper from './TitleWrapper';
import Header from './Header';
Base.displayName = "AccordionBase";
Header.displayName = "Accordion.Header";
Body.displayName = "Accordion.Body";
Text.displayName = "Accordion.Text";
Title.displayName = "Accordion.Title";
SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";
export { Base as default, Text, Body, ContentWrapper, Icon, Title, SubTitle, Header, TitleWrapper, JsonLdFaq };